import { create } from 'zustand';

export const useTaskCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  openTaskCreate: (payload) => set({ isOpen: true, payload }),
  close: () => set({ isOpen: false, payload: {} })
}));
export const openTaskCreate = (payload) => {
  const store = useTaskCreateStore.getState();
  store.openTaskCreate(payload);
};

export const closeTaskCreate = () => {
    console.log("closed called");
  const store = useTaskCreateStore.getState();
  store.close();
};